import { initializeApp, getApps, getApp } from 'firebase/app'
import { getFirestore, initializeFirestore, Firestore } from 'firebase/firestore'
import { getStorage, FirebaseStorage } from 'firebase/storage'

export const firebaseConfig = {
  apiKey: 'AIzaSyD9YsMrCXpOxd8r-ieM40uGy5_u7BHBmLE',
  authDomain: 'mamf-slides.firebaseapp.com',
  projectId: 'mamf-slides',
  storageBucket: 'mamf-slides.firebasestorage.app',
  messagingSenderId: '285966344323',
  appId: '1:285966344323:web:6d8f9a790886a921543bb6',
  measurementId: 'G-JKDX1341XR',
}

let dbInstance: Firestore | null = null
let storageInstance: FirebaseStorage | null = null

export const getDb = (): Firestore | null => {
  if (typeof window === 'undefined') return null
  if (!dbInstance) {
    try {
      const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig)
      try {
        dbInstance = initializeFirestore(app, {
          ignoreUndefinedProperties: true,
        })
      } catch {
        dbInstance = getFirestore(app)
      }
    } catch (err) {
      console.warn('Firebase Firestore initialization deferred:', err)
      return null
    }
  }
  return dbInstance
}

export const getStorageInstance = (): FirebaseStorage | null => {
  if (typeof window === 'undefined') return null
  if (!storageInstance) {
    try {
      const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig)
      storageInstance = getStorage(app)
    } catch (err) {
      console.warn('Firebase Storage initialization deferred:', err)
      return null
    }
  }
  return storageInstance
}

